module.exports = __webpack_public_path__ + "img/alerts-5-mobile.f2b4ca8b.gif";